<template>
  <div style="padding: 10px 15px">
    <div class="assmt-header d-flex justify-content-between">
      <div class="assmt-title">Damage Assessment</div>
      <div class="assmt-info-repx-icon">
        <img src="../../../assets/icon/orm-repx-icon.png" height="40" width="40"/>
      </div>
    </div>
    <div class="assmt-main">
      <div class="assmt-svg">
        <div class="assmt-svg-diag d-flex">
          <div class="assmt-svg-diag-left">
            <div class="assmt-svg-diag-icon-top"
                 @click.stop.prevent="contextShow($event, 'side', 'left1')"
                 @contextmenu.stop.prevent="contextShow($event, 'side', 'left1')">
              <i class='bx bx-edit' :class="{ active: (sections.left1 || 0) > 0 }"></i>
            </div>

            <div class="assmt-svg-diag-icon-center"
                 @click.stop.prevent="contextShow($event, 'side', 'left2')"
                 @contextmenu.stop.prevent="contextShow($event, 'side', 'left2')">
              <i class='bx bx-edit' :class="{ active: (sections.left2 || 0) > 0 }"></i>
            </div>

            <div class="assmt-svg-diag-icon-bottom"
                 @click.stop.prevent="contextShow($event, 'side', 'left3')"
                 @contextmenu.stop.prevent="contextShow($event, 'side', 'left3')">
              <i class='bx bx-edit' :class="{ active: (sections.left3 || 0) > 0 }"></i>
            </div>
            <div class="assmt-svg-diag-left-top assmt-svg-diag-item" :class="{ active: (sections.left1 || 0) > 0 }"></div>
            <div class="assmt-svg-diag-left-center assmt-svg-diag-item" :class="{ active: (sections.left2 || 0) > 0 }"></div>
            <div class="assmt-svg-diag-left-bottom assmt-svg-diag-item" :class="{ active: (sections.left3 || 0) > 0 }"></div>
          </div>
          <div class="assmt-svg-diag-center assmt-svg-diag-item" :class="{ active: (sections.center || 0) > 0 }">
            <div @click.stop.prevent="contextShow($event, 'center', 'center')"
                 @contextmenu.stop.prevent="contextShow($event, 'center', 'center')">
              <i class='bx bx-edit' :class="{ active: (sections.center || 0) > 0 }"></i>
            </div>
          </div>
          <div class="assmt-svg-diag-right">
            <div class="assmt-svg-diag-right-top assmt-svg-diag-item" :class="{ active: (sections.right1 || 0) > 0 }"></div>
            <div class="assmt-svg-diag-right-center assmt-svg-diag-item" :class="{ active: (sections.right2 || 0) > 0 }"></div>
            <div class="assmt-svg-diag-right-bottom assmt-svg-diag-item" :class="{ active: (sections.right3 || 0) > 0 }"></div>
            <div class="assmt-svg-diag-icon-top"
                 @click.stop.prevent="contextShow($event, 'side', 'right1')"
                 @contextmenu.stop.prevent="contextShow($event, 'side', 'right1')">
              <i class='bx bx-edit' :class="{ active: (sections.right1 || 0) > 0 }"></i>
            </div>
            <div class="assmt-svg-diag-icon-center"
                 @click.stop.prevent="contextShow($event, 'side', 'right2')"
                 @contextmenu.stop.prevent="contextShow($event, 'side', 'right2')">
              <i class='bx bx-edit' :class="{ active: (sections.right2 || 0) > 0 }"></i>
            </div>
            <div class="assmt-svg-diag-icon-bottom"
                 @click.stop.prevent="contextShow($event, 'side', 'right3')"
                 @contextmenu.stop.prevent="contextShow($event, 'side', 'right3')">
              <i class='bx bx-edit' :class="{ active: (sections.right3 || 0) > 0 }"></i>
            </div>
          </div>
        </div>
        <svg-other-prem :selectedSchemeParts="uniqueSelectedSchemeParts"
                        class="assmt-svg-car"/>
      </div>
      <div class="assmt-info">
        <div class="assmt-info-repx-icon">
          <img src="../../../assets/icon/orm-repx-icon.png" height="40" width="40"/>
        </div>
        <div class="form-group row">
          <label for="owner" class="col-sm-4 col-4 col-form-label">Rego</label>
          <div class="col-sm-8 col-8">
            <input style="opacity: 1" type="text" v-model="rego" class="form-control text-uppercase"
                   id="owner" placeholder="">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-4 col-form-label">Rego State</label>
          <div class="col-sm-8 col-8">
            <multiselect
                v-model="regoStateModel"
                :options="regoStateOptions"
                :showLabels="false"
                :option-height="29"
                :max-height="400"
                placeholder="Select State"
                track-by="key"
                label="key"
                :allow-empty="true"
                style="opacity: 1">
            </multiselect>
          </div>
        </div>
        <div class="form-group row">
          <label for="owner" class="col-sm-4 col-4 col-form-label">Make</label>
          <div class="col-sm-8 col-8">
            <input style="opacity: 1" type="text" v-model="make" class="form-control text-uppercase"
                   id="owner" placeholder="">
          </div>
        </div>
        <div class="form-group row">
          <label for="owner" class="col-sm-4 col-4 col-form-label">Model</label>
          <div class="col-sm-8 col-8">
            <input style="opacity: 1" type="text" v-model="model" class="form-control text-uppercase"
                   id="owner" placeholder="">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">PAV</label>
          <div class="col-sm-8">
            <number-formatter
                v-model="pav"
                type="text"
                class="form-control"
                placeholder="PAV"
                format="$0,0.00"
            ></number-formatter>
          </div>
        </div>
        <div class="form-group row form-group-img">
          <div class="col-sm-4 col-4"></div>
          <img class="col-sm-8 col-8" :src="pinnedImageSrc"/>
<!--               :src="imageList.Uncategorised[2].src"-->
        </div>
        <div class="form-group row form-group-icon" style="position: relative">
          <label class="col-sm-4 col-4 col-form-label">Interior</label>
          <div class="col-sm-8 col-8">
            <multiselect
                ref="interiorSelect"
                v-model="interior"
                :options="interiorOptions"
                :allow-empty="false"
                :custom-label="damageLabel"
                :showLabels="false"
                :option-height="29"
                :max-height="203"
                style="opacity: 1">
            </multiselect>
          </div>
          <div class="assmt-info-icon" @click.stop.prevent="openMultiselect('interiorSelect')">
            <i class='bx bx-edit'></i>
          </div>
        </div>
        <div class="form-group row form-group-icon" style="position: relative">
          <label class="col-sm-4 col-4 col-form-label">Engine</label>
          <div class="col-sm-8 col-8">
            <multiselect
                ref="engineSelect"
                v-model="engine"
                :options="engineOptions"
                :allow-empty="false"
                :custom-label="damageLabel"
                :showLabels="false"
                :option-height="29"
                :max-height="203"
                style="opacity: 1">
            </multiselect>
          </div>
          <div class="assmt-info-icon" @click.stop.prevent="openMultiselect('engineSelect')">
            <i class='bx bx-edit'></i>
          </div>
        </div>
      </div>
    </div>

    <vue-context ref="leftClickMenu" @open="contextOpen">
      <ul>
        <li :class="{ 'assmt-menu-active': activeSectionValue === 0 }" @click="setSectionValue(0)">None</li>
        <li v-if="!isCenterClick" :class="{ 'assmt-menu-active': activeSectionValue === 1 }" @click="setSectionValue(1)">Panel Repair</li>
        <li v-if="!isCenterClick" :class="{ 'assmt-menu-active': activeSectionValue === 2 }" @click="setSectionValue(2)">Panel Replace</li>
        <li :class="{ 'assmt-menu-active': activeSectionValue === 3 }" @click="setSectionValue(3)">Structural Repair</li>
        <li :class="{ 'assmt-menu-active': activeSectionValue === 4 }" @click="setSectionValue(4)">Structural Replace</li>
      </ul>
    </vue-context>
  </div>
</template>

<script>
import { VueContext } from 'vue-context'
import SvgOtherPrem from '@/components/estimates/estimate-edit/svg-assessment/other-prem.vue'
import Multiselect from 'vue-multiselect'
import NumberFormatter from '@/components/utility/number-formatter.vue'

export default {
  name: 'damage-assessment-prem',
  data() {
    return {
      activeSectionKey: null,
      contextOpenEvent: null,
      isCenterClick: false,
      suppressAssessmentEmit: false,
      rego: '',
      make: '',
      model: '',
      regoState: null,
      regoStateOptions: [
        { key: '', value: '' },
        { key: 'NSW', value: 'NSW' },
        { key: 'QLD', value: 'QLD' },
        { key: 'VIC', value: 'VIC' },
        { key: 'ACT', value: 'ACT' },
        { key: 'TAS', value: 'TAS' },
        { key: 'SA', value: 'SA' },
        { key: 'WA', value: 'WA' },
        { key: 'NT', value: 'NT' },
      ],
      pav: '',
      interior: 0,
      interiorOptions: [0, 1, 2],
      engine: 0,
      engineOptions: [0, 1, 2],
      sections: {
        left1: 0,
        left2: 0,
        left3: 0,
        right1: 0,
        right2: 0,
        right3: 0,
        center: 0,
      }
    }
  },
  props: {
    assessment: {},
    // CHANGE damage-assessment-prem.vue:L223 - pinned image object from parent (selected where isPinned === true)
    pinImage: {},
    selectedSchemeParts: {
      type: Array,
      default: () => {
        return []
      }
    },
    body: {
      type: String,
      default: ''
    },
  },
  components: { NumberFormatter, Multiselect, SvgOtherPrem, VueContext },
  computed: {
    regoStateModel: {
      get() {
        const code = this.regoState
        return this.regoStateOptions.find(o => o.value === code) || this.regoStateOptions[0]
      },
      set(option) {
        this.regoState = option?.value ?? ''
      }
    },
    pinnedImageSrc() {
      // CHANGE damage-assessment-prem.vue:L246-L248 - use pinImage passed from parent
      return this.pinImage?.previewW220 ?? null
    },
    uniqueSelectedSchemeParts() {
      if (!Array.isArray(this.selectedSchemeParts)) return [];
      return [...new Set(this.selectedSchemeParts)];
    },
    activeSectionValue() {
      if (!this.activeSectionKey) return null;
      return (this.sections && this.sections[this.activeSectionKey] !== undefined)
        ? this.sections[this.activeSectionKey]
        : null;
    }
  },
  methods: {
    contextShow(event, type, sectionKey) {
      this.activeSectionKey = sectionKey;
      if (this.$refs.leftClickMenu) {
        this.$nextTick(() => {
          this.$refs.leftClickMenu.open(event);
          this.isCenterClick = (type === 'center');
        });
      }
    },
    contextOpen(event) {
      this.contextOpenEvent = event;
    },
    openMultiselect(refName) {
      const ms = this.$refs[refName];
      if (!ms) return;
      if (typeof ms.activate === 'function') ms.activate();
      ms.isOpen = true;
    },
    emitAssessmentUpdate() {
      if (this.suppressAssessmentEmit) return;

      this.$emit('update-assessment', {
        rego: this.rego,
        regoState: this.regoState,
        make: this.make,
        model: this.model,
        pav: this.pav,
        sections: {
          ...this.sections,
          interior: this.interior,
          engine: this.engine,
        }
      });
    },
    damageLabel(code) {
      const n = Number(code);
      if (n === 0) return 'None';
      if (n === 1) return 'Minor Damage';
      if (n === 2) return 'Major Damage';
      return '';
    },
    normalizeDamageCode(value) {
      const n = Number(value);
      if (n === 0 || n === 1 || n === 2) return n;
      return 0;
    },
    toUpperSafe(value) {
      if (value === null || value === undefined) return '';
      return String(value).toUpperCase();
    },
    applyAssessmentToForm(a) {
      if (!a) return;
      this.suppressAssessmentEmit = true;
      const vehicle = a.vehicle || a.car || a.vehicle_info || {};
      const insurance = a.insurance || a.claim || {};
      this.rego = this.toUpperSafe(a.rego ?? a.rego_number ?? vehicle.rego_number ?? vehicle.rego ?? this.rego);
      this.make = this.toUpperSafe(a.make ?? vehicle.make ?? this.make);
      this.model = this.toUpperSafe(a.model ?? vehicle.model ?? this.model);

      const nextState = a.regoState ?? a.rego_state ?? vehicle.rego_state ?? vehicle.state ?? this.regoState
      const nextStateUpper = this.toUpperSafe(nextState)
      this.regoState = this.regoStateOptions.some(o => o.value === nextStateUpper) ? nextStateUpper : ''
      this.pav = a.pav ?? insurance.pav ?? this.pav;
      this.interior = this.normalizeDamageCode(a?.sections?.interior ?? a.interior);
      this.engine = this.normalizeDamageCode(a?.sections?.engine ?? a.engine);

      // 2) Sections
      // Если в assessment sections лежит объектом такого же вида как this.sections
      const sections = a.sections ?? a.damage_sections ?? a.damage?.sections;
      if (sections && typeof sections === 'object') {
        this.sections = {
          ...this.sections,
          ...sections,
        };
      }

      // ADD damage-assessment-prem.vue:L3xx - allow emits after the DOM/reactivity cycle
      this.$nextTick(() => {
        this.suppressAssessmentEmit = false;
      });
    },
    setSectionValue(val) {
      if (!this.activeSectionKey) return;

      // Обновляем локальную форму
      this.$set(this.sections, this.activeSectionKey, val);

      this.$emit('update-sections', {
        key: this.activeSectionKey,
        value: val,
        sections: { ...this.sections }
      });

      // ADD damage-assessment-prem.vue:L3xx - propagate full assessment change
      this.emitAssessmentUpdate();
    },
  },
  watch: {
    // ADD around damage-assessment-prem.vue:L186
    assessment: {
      immediate: true,
      deep: true,
      handler(val) {
        this.applyAssessmentToForm(val);
      }
    },
    // ADD damage-assessment-prem.vue:L3xx - uppercase on user input
    rego(val) {
      const upper = this.toUpperSafe(val);
      if (val !== upper) this.rego = upper;
      // ADD damage-assessment-prem.vue:L3xx
      this.emitAssessmentUpdate();
    },
    make(val) {
      const upper = this.toUpperSafe(val);
      if (val !== upper) this.make = upper;
      // ADD damage-assessment-prem.vue:L3xx
      this.emitAssessmentUpdate();
    },
    model(val) {
      const upper = this.toUpperSafe(val);
      if (val !== upper) this.model = upper;
      // ADD damage-assessment-prem.vue:L3xx
      this.emitAssessmentUpdate();
    },
    // ADD damage-assessment-prem.vue:L3xx - propagate other field changes
    regoState() {
      this.emitAssessmentUpdate();
    },
    pav() {
      this.emitAssessmentUpdate();
    },
    interior() {
      this.emitAssessmentUpdate();
    },
    engine() {
      this.emitAssessmentUpdate();
    }
  },
}
</script>

<style scoped>
.assmt-title{
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  color: #1C1F39;
}
.assmt-menu-active{
  background: rgba(93, 120, 253, 0.15);
  color: #1d4898;
  font-weight: 600;
}
.text-uppercase{
  text-transform: uppercase;
}
.assmt-info-icon .bx-edit,
.assmt-svg-diag-left .bx-edit,
.assmt-svg-diag-center .bx-edit,
.assmt-svg-diag-right .bx-edit{
  cursor: pointer;
}
.assmt-main{
  display: flex;
}
.assmt-svg{
  min-width: 1160px;
  margin-top: 50px;
  position: relative;
  right: 250px;
  overflow: visible;
}

.assmt-svg-diag{
  width: 464px;
  position: absolute;
  z-index: 2;
  right: 362px;
}

.assmt-svg-diag-left,
.assmt-svg-diag-right{
  width: 50%;
  height: 410px;
  margin-top: 10px;
  position: relative;
}

.assmt-svg-diag-center{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -8%);
  z-index: 3;
  border: 3px dashed #1a7bc2;
  height: 100px;
  width: 70px;
  background-color: #ecdfdf;
}

.assmt-svg-diag-left-top{
  height: 33%;
  border-bottom: 3px dashed #1a7bc2;
  border-right: 3px dashed #1a7bc2;
}

.assmt-svg-diag-left-center{
  height: 43%;
  border-right: 3px dashed #1a7bc2;
  border-bottom: 3px dashed #1a7bc2;
}

.assmt-svg-diag-left-bottom{
  height: 24%;
  border-right: 3px dashed #1a7bc2;
}

.assmt-svg-diag-right-top{
  height: 33%;
  border-bottom: 3px dashed #1a7bc2;
}

.assmt-svg-diag-right-center{
  height: 43%;
  border-bottom: 3px dashed #1a7bc2;
}

.assmt-svg-diag-right-bottom{
  height: 24%;
}

.assmt-svg-car{
  z-index: 1;
  position: relative;
}

.assmt-svg-diag-item.active,
.assmt-svg-diag-item:hover{
  background-color: rgba(93, 120, 253, 0.15);
}

.assmt-svg-diag-center.assmt-svg-diag-item.active,
.assmt-svg-diag-center.assmt-svg-diag-item:hover{
  background-color: rgb(215, 207, 227);
}

.assmt-svg-diag-left .bx-edit,
.assmt-svg-diag-center .bx-edit,
.assmt-svg-diag-right .bx-edit{
  font-size: 23px;
  color: #1d4898;
}

.assmt-svg-diag-center .bx-edit{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.assmt-svg-diag-left .bx-edit.active,
.assmt-svg-diag-center .bx-edit.active,
.assmt-svg-diag-right .bx-edit.active,
.assmt-svg-diag-center .bx-edit.active{
  color: rgb(255, 94, 94)
}

.assmt-svg-diag-left .assmt-svg-diag-icon-top{
  position: absolute;
  left: -25px;
  top: 10px;
}

.assmt-svg-diag-right .assmt-svg-diag-icon-top{
  position: absolute;
  right: -25px;
  top: 10px;
}

.assmt-svg-diag-left .assmt-svg-diag-icon-center{
  position: absolute;
  top: 50%;
  left: -25px;
}

.assmt-svg-diag-right .assmt-svg-diag-icon-center{
  position: absolute;
  top: 50%;
  right: -25px;
}

.assmt-svg-diag-left .assmt-svg-diag-icon-bottom{
  position: absolute;
  bottom: 5px;
  left: -25px;
}

.assmt-svg-diag-right .assmt-svg-diag-icon-bottom{
  position: absolute;
  bottom: 5px;
  right: -25px;
}

.assmt-info{
  width: 250px;
  min-width: 250px;
  position: relative;
  right: 450px;
  z-index: 2;
}

.assmt-info-repx-icon{
  text-align: right;
  margin-right: 15px;
  margin-bottom: 10px;
}

.assmt-info label{
  text-align: right;
  white-space: nowrap;
  padding-right: 0;
}

.assmt-info .assmt-info-icon .bx-edit{
  font-size: 23px;
  color: #1d4898;
  cursor: pointer;
}

.assmt-info .assmt-info-icon{
  position: absolute;
  right: -20px;
  top: 4px;
}
.assmt-header .assmt-info-repx-icon{
  display: none;
}
.assmt-main .assmt-info-repx-icon{
  display: block;
}
.form-group-img img{
  object-fit: cover;
  height: 87px;
}

@media screen and (max-width: 1300px) {
  .assmt-info{
    right: 540px;
  }
}
@media screen and (max-width: 1150px) {
  .assmt-main{
    display: block;
  }
  .assmt-info{
    right: -70px;
    margin-top: 40px;
  }
  .assmt-header{
    max-width: 600px;
  }
  .assmt-header .assmt-info-repx-icon{
    display: block;
  }
  .assmt-main .assmt-info-repx-icon{
    display: none;
  }
}
@media screen and (max-width: 630px) {
  .assmt-svg{
    min-width: 730px;
    right: 185px;
    margin-top: 10px;
  }
  .assmt-svg-diag{
    width: 291px;
    right: 229px;
  }
  .assmt-svg-diag-left,
  .assmt-svg-diag-right{
    height: 250px;
  }
  .assmt-svg-diag-left-top{
    height: 32%;
  }

  .assmt-svg-diag-left-center{
    height: 47%;
  }

  .assmt-svg-diag-left-bottom{
    height: 25%;
  }

  .assmt-svg-diag-right-top{
    height: 32%;
  }

  .assmt-svg-diag-right-center{
    height: 47%;
  }

  .assmt-svg-diag-right-bottom{
    height: 25%;
  }

  .assmt-svg-diag-center{
    width: 46px;
    height: 66px;
    transform: translate(-50%, -5%);
  }

  .assmt-info{
    right: 0;
    width: 100%;
  }

  .form-group-icon{
    width: 90%;
  }

  .form-group-icon .assmt-info-icon{
    top: 33px;
  }

  .form-group-img img{
    height: 150px;
  }
}
</style>
